export default "__VITE_ASSET__Be0zOavE__"